// lib
import { connect } from "react-redux";
// src
import Component from "components/plannings/routes/Home";
import { resetRedirect } from "actions/user";
import { fetchEnableds } from "actions/events/thunks";
import { fetchPopulars } from "actions/presets/thunks";
import { fetchUserState } from "actions/user/thunks";

const mapStateToProps = ({
  events: { needsRefresh },
  user: { isLogged, isStateInitialized, redirectTarget },
}) => ({
  needsUserState: isLogged && !isStateInitialized,
  needsRefresh,
  redirectTarget,
});

const mapDispatchToProps = {
  fetchEnableds,
  fetchUserState,
  fetchPopulars,
  resetRedirect,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
